import { createContext } from 'react';
const defaultContext = {
    vulnReportPath: '',
};
/** Data context for notification data */
export const notificationContext = createContext(defaultContext);
